// tslint:disable
export enum QueryStringMatch {
    /**
     * @description Exact
     */
    Exact = 0,
    /**
     * @description Starts With
     */
    StartsWith = 1,
    /**
     * @description Ends With
     */
    EndsWith = 2,
    /**
     * @description Contains
     */
    Contains = 3,
}
(QueryStringMatch as any)['EXACT'] = 0;
(QueryStringMatch as any)['STARTSWITH'] = 1;
(QueryStringMatch as any)['ENDSWITH'] = 2;
(QueryStringMatch as any)['CONTAINS'] = 3;
